import { theme } from '@ketch-com/deck'
import { Box, styled } from '@mui/material'
import { AuditLogPieChart } from 'pages/insights/auditLog/components/consentsTab/components/AuditLogPieChart'
import { useConsentTabAggregateData } from 'pages/insights/auditLog/components/consentsTab/hooks/useConsentTabAggregateData'

const AggregateInfoBox = styled(Box)({
  display: 'flex',
  gap: '48px',
})

export const ConsentTabAggregateInfo = () => {
  const { aggregateData } = useConsentTabAggregateData()
  return (
    <AggregateInfoBox>
      <AuditLogPieChart
        primaryItems={aggregateData.consentRate.optedInPurposes}
        secondaryItems={aggregateData.consentRate.optedOutPurposes}
        title="Allowance Rate"
        description="Purposes Opted In"
        primaryItemName="Opted In Purposes"
        secondaryItemName="Opted Out Purposes"
        width="271px"
      />
      <AuditLogPieChart
        primaryItems={aggregateData.adherenceRate.defaultNotOverridenPurposes}
        secondaryItems={aggregateData.adherenceRate.defaultOverridenPurposes}
        title="Consent State Adherence"
        description="Default Consent State Set"
        primaryItemName="Not Overridden Purposes"
        secondaryItemName="Overridden Purposes"
        tooltip="How often the default consent state was set for a purpose. The default consent state is determined by the legal basis of that purpose in the jursidiction where the consent record originated."
      />
      <AuditLogPieChart
        primaryItems={aggregateData.identityMatchRate.successfulConnections}
        secondaryItems={aggregateData.identityMatchRate.missingIdentityConnections}
        title="Identity Match Rate"
        description="Connection Identities Found"
        primaryItemName="Connections With Identities"
        secondaryItemName="Connections Missing Identities"
        primaryColor={theme.palette.Infographics.BlueD.Primary}
        tooltip="How often the identity required to orchestrate consent to a particular system was present at the time the consent record was created."
      />
    </AggregateInfoBox>
  )
}
